export class PageHistory {
workflowId = 0;
pageId = '';
pageNumber = -1;
questionId = '';
questionText = '';
otherText = '';
isRemoved = false;
}